import Component from '../component';

export default class TooltipTrigger extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.bindEvents();
  }

  bindEvents() {
    this.$element.tooltip();
  }

  unbindEvents() {
    this.$element.tooltip('destroy');
  }
}
